module.exports = __webpack_public_path__ + "static/media/presentX.8c0fa561.png";